import { isTauri, tauriInvoke } from "../utils/tauri";

// runtime cache
let loaded = false;
let cfg = {
  baseUrl: "https://new.itable.app/api",
  token: "",
};

async function loadFromTauri() {
  const s = await tauriInvoke<Record<string, any>>("get_device_settings", { keys: ["api_base_url", "device_token"] });
  cfg.baseUrl = (s?.api_base_url as string) || cfg.baseUrl;
  cfg.token = (s?.device_token as string) || cfg.token;
}

async function loadFromBrowser() {
  const lsApi = localStorage.getItem("api") || localStorage.getItem("api_base_url");
  const envApi = (import.meta as any).env?.REACT_APP_API_BASE_URL || (import.meta as any).env?.VITE_API_BASE_URL;
  cfg.baseUrl = (lsApi || envApi || cfg.baseUrl).replace(/\/+$/, "");
  cfg.token = localStorage.getItem("device_token") || localStorage.getItem("token") || cfg.token;
}

export async function loadRuntimeConfig() {
  try {
    if (isTauri()) await loadFromTauri();
    else await loadFromBrowser();
  } finally {
    loaded = true;
  }
  return cfg;
}

export async function getRuntimeConfig() {
  if (!loaded) await loadRuntimeConfig();
  return cfg;
}

// kad sačuvaš podešavanja iz UI
export async function refreshRuntimeConfig() {
  loaded = false;
  return loadRuntimeConfig();
}

// ako želiš ručno postaviti (npr. nakon “bootstrap” wizard-a)
export function setRuntimeConfig(partial: Partial<typeof cfg>) {
  cfg = { ...cfg, ...partial };
  loaded = true;
}
